import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"];
  static values = { id: String };

  toggle(event) {
    const actualTab = event.target;
    $(`#${this.idValue}`).attr('src', actualTab.dataset.href);
    this.tabTargets.forEach(tab => {
      if (actualTab === tab) {
        tab.classList.replace("inactive", "active");
      } else {
        tab.classList.replace("active", "inactive");
      }
    });
  }
}
